import React from 'react';
import styled, { css } from 'styled-components';
import { color, gutter } from '../../styles/mixins';
import { caps14 } from '../../styles/typography';

const Host = styled.div<{ divider: boolean }>`
  padding-bottom: ${gutter(3.5)};
  display: block;
  ${(props) =>
    props.divider === true &&
    css`
      border-top: 1px solid ${color('gray30')};
      padding-top: ${gutter(3.5)};
    `}
`;

const Title = styled.p`
  ${caps14};
  margin-bottom: ${gutter(3.5)};
`;

const Childs = styled.div`
  > * {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

interface FieldGroupProps {
  title?: string;
  children: React.ReactNode;
  divider?: boolean;
}

export const FieldGroup = ({
  title,
  children,
  divider = true,
}: FieldGroupProps) => {
  return (
    <Host divider={divider}>
      {title && <Title>{title}</Title>}
      <Childs>{children}</Childs>
    </Host>
  );
};
